import React from 'react';
import './style.scss';
import { Image, Text } from '@sitecore-jss/sitecore-jss-react';
import icons from '../../../../../../../common/Icons';
import Sticky from 'react-sticky-el';
import clsx from 'clsx';

const headerRow = ({ items, removeItem, hidden }) => {
  return (
    <tr className={clsx('cct-header-row', hidden && 'cct-header-row-hidden')}>
      <th />
      {items.map((item, index) => (
        <th key={index} className="cct-header-cell">
          <div className="cct-header-cell-content">
            <div className="cct-hcc-image-wrapper">
              <Image field={item.fields.image} className="cct-hcc-image" />
            </div>
            <Text field={item.fields.heading} />
            {items.length >= 3 && (
              <button className="cct-hcc-delete-button" onClick={() => removeItem(index)}>
                <img src={icons.crossCircle} />
              </button>
            )}
          </div>
        </th>
      ))}
    </tr>
  );
};

const CardsCompareTableHeader = ({ items, removeItem, isSticky, hidden }) => (
  <thead>
    {isSticky ? (
      <Sticky bottomOffset={0} scrollElement=".custom-modal">
        {headerRow({ items, removeItem, hidden })}
      </Sticky>
    ) : (
      headerRow({ items, removeItem, hidden })
    )}
  </thead>
);

export default CardsCompareTableHeader;
